import EnhancedModal from "../../../components/enhanced-modal";
import {MODAL_WIDTH_MD} from "../../../styles/constants";
import {Button, Modal} from "antd";
import React, {Fragment} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {DSD_DIMENSION_TYPE_MEASURE} from "../../../utils/sdmxJson";
import ComponentForm, {DSD_COMPONENT_TYPE_DIMENSION} from "../dsd-detail/ComponentForm";
import {
  ARTEFACT_FORM_MODE_CREATE,
  ARTEFACT_FORM_MODE_EDIT,
  ARTEFACT_FORM_MODE_READ
} from "../../../components/artefact-form";
import {existsComponentWithId} from "../../../utils/artefacts";
import {
  changeDsdDetailComponentDefault,
  changeDsdDetailComponentNotDisplayed,
  changeDsdDetailDefaultTimeDimensionEnd,
  changeDsdDetailDefaultTimeDimensionLastNObservations,
  changeDsdDetailDefaultTimeDimensionLastNPeriods, changeDsdDetailDefaultTimeDimensionMode,
  changeDsdDetailDefaultTimeDimensionStart,
  changeDsdDetailDimension,
  hideDsdDetailDimension,
  showDsdDetailCodelistsForSelector,
  showDsdDetailConceptSchemesForSelector,
  showDsdDetailDefaultCodesSelector,
  showDsdDetailHierarchicalCodelistsForSelector,
  showDsdDetailMeasureDimensionConceptSchemesForSelector,
  showDsdDetailNotDisplayedCodesSelector,
  submitDsdDetailDimension
} from "../actions";
import {reuseAction} from "../../../utils/reduxReuse";

const mapStateToProps = (state, {instanceState}) => ({
  dimension: instanceState.dimension,
  dsdTriplet: instanceState.dsdTriplet,
  dsd: instanceState.dsd,
  isCreatingComponent: instanceState.isCreatingComponent,
  notDisplayedVal: instanceState.notDisplayedVal,
  defaultVal: instanceState.defaultVal,
  defaultTimeDimensionStart: instanceState.defaultTimeDimensionStart,
  defaultTimeDimensionEnd: instanceState.defaultTimeDimensionEnd,
  defaultTimeDimensionLastNObservations: instanceState.defaultTimeDimensionLastNObservations,
  defaultTimeDimensionLastNPeriods: instanceState.defaultTimeDimensionLastNPeriods,
  defaultTimeDimensionMode: instanceState.defaultTimeDimensionMode
});

const mapDispatchToProps = (dispatch, {instancePrefix}) => ({
  onCodelistsForSelectorShow: () => dispatch(reuseAction(showDsdDetailCodelistsForSelector(), instancePrefix)),
  onConceptSchemesForSelectorShow: () => dispatch(reuseAction(showDsdDetailConceptSchemesForSelector(), instancePrefix)),
  onMeasureDimensionConceptSchemesForSelectorShow: () => dispatch(reuseAction(showDsdDetailMeasureDimensionConceptSchemesForSelector(), instancePrefix)),
  onHide: () => dispatch(reuseAction(hideDsdDetailDimension(), instancePrefix)),
  onChange: fields => dispatch(reuseAction(changeDsdDetailDimension(fields), instancePrefix)),
  onNotDisplayedValChange: val => dispatch(reuseAction(changeDsdDetailComponentNotDisplayed(val), instancePrefix)),
  onDefaultValChange: val => dispatch(reuseAction(changeDsdDetailComponentDefault(val), instancePrefix)),
  onDefaultTimeDimensionStartChange: val => dispatch(reuseAction(changeDsdDetailDefaultTimeDimensionStart(val), instancePrefix)),
  onDefaultTimeDimensionEndChange: val => dispatch(reuseAction(changeDsdDetailDefaultTimeDimensionEnd(val), instancePrefix)),
  onDefaultTimeDimensionLastNObservationsChange: val => dispatch(reuseAction(changeDsdDetailDefaultTimeDimensionLastNObservations(val), instancePrefix)),
  onDefaultTimeDimensionLastNPeriodsChange: val => dispatch(reuseAction(changeDsdDetailDefaultTimeDimensionLastNPeriods(val), instancePrefix)),
  onDefaultTimeDimensionModeChange: val => dispatch(reuseAction(changeDsdDetailDefaultTimeDimensionMode(val), instancePrefix)),
  onSubmit: () => dispatch(reuseAction(submitDsdDetailDimension(), instancePrefix)),
  onNotDisplayedCodesSelectorShow: codelistTriplet => dispatch(reuseAction(showDsdDetailNotDisplayedCodesSelector(codelistTriplet), instancePrefix)),
  onDefaultCodesSelectorShow: codelistTriplet => dispatch(reuseAction(showDsdDetailDefaultCodesSelector(codelistTriplet), instancePrefix)),
  onHierarchicalCodelistsForSelectorShow: () => dispatch(reuseAction(showDsdDetailHierarchicalCodelistsForSelector(), instancePrefix)),
});

const DsdsDimensionDetail = ({
                               t,
                               dimension,
                               dsdTriplet,
                               dsd,
                               userHasPermissionsToEdit,
                               notDisplayedVal,
                               defaultVal,
                               defaultTimeDimensionStart,
                               defaultTimeDimensionEnd,
                               defaultTimeDimensionLastNObservations,
                               defaultTimeDimensionLastNPeriods,
                               defaultTimeDimensionMode,
                               onHide,
                               onChange,
                               onNotDisplayedValChange,
                               onDefaultValChange,
                               onDefaultTimeDimensionStartChange,
                               onDefaultTimeDimensionEndChange,
                               onDefaultTimeDimensionLastNObservationsChange,
                               onDefaultTimeDimensionLastNPeriodsChange,
                               onDefaultTimeDimensionModeChange,
                               onSubmit,
                               isCreatingComponent,
                               onCodelistsForSelectorShow,
                               onConceptSchemesForSelectorShow,
                               onMeasureDimensionConceptSchemesForSelectorShow,
                               onNotDisplayedCodesSelectorShow,
                               onDefaultCodesSelectorShow,
                               onHierarchicalCodelistsForSelectorShow
                             }) => {

  const isDisabledAnnotations = !isCreatingComponent && dsdTriplet !== null && !userHasPermissionsToEdit;

  return (
    <EnhancedModal
      visible={dimension !== null}
      width={MODAL_WIDTH_MD}
      title={t('reduxComponents.dsdDetail.dimensionDetail.title')}
      onCancel={onHide}
      footer={
        <Fragment>
          <Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>
          {(dsdTriplet === null || (dsd && !dsd.remoteIsFinal && userHasPermissionsToEdit) ||
            !isDisabledAnnotations) && (
            <Button
              disabled={
                !(
                  dimension && dimension.type && dimension.id && dimension.concept &&
                  (dimension.type !== DSD_DIMENSION_TYPE_MEASURE || dimension.representation) &&
                  (dimension.annotations || []).filter(annot =>
                    annot.id === null || (annot.id !== undefined && annot.id.length === 0) ||
                    annot.type === null || (annot.type !== undefined && annot.type.length === 0)
                  ).length === 0
                )
              }
              onClick={
                () =>
                  isCreatingComponent && existsComponentWithId(dsd, dimension.id)
                    ? Modal.warning({
                      title: t('reduxComponents.dsdDetail.component.createWarningModal.title', {id: dimension.id}),
                      content: t('reduxComponents.dsdDetail.component.createWarningModal.content')
                    })
                    : onSubmit()
              }
              type="primary"
            >
              {t('commons.buttons.save.title')}
            </Button>
          )}
        </Fragment>
      }
      withDataLanguageSelector
    >
      <ComponentForm
        type={DSD_COMPONENT_TYPE_DIMENSION}
        component={dimension}
        mode={
          isCreatingComponent
            ? ARTEFACT_FORM_MODE_CREATE
            : (
              dsdTriplet === null || (dsd && !dsd.remoteIsFinal && userHasPermissionsToEdit)
                ? ARTEFACT_FORM_MODE_EDIT
                : ARTEFACT_FORM_MODE_READ
            )
        }
        disableAnnotations={isDisabledAnnotations}
        notDisplayedVal={notDisplayedVal}
        defaultVal={defaultVal}
        defaultTimeDimensionStart={defaultTimeDimensionStart}
        defaultTimeDimensionEnd={defaultTimeDimensionEnd}
        defaultTimeDimensionLastNObservations={defaultTimeDimensionLastNObservations}
        defaultTimeDimensionLastNPeriods={defaultTimeDimensionLastNPeriods}
        defaultTimeDimensionMode={defaultTimeDimensionMode}
        onChange={onChange}
        onNotDisplayedValChange={onNotDisplayedValChange}
        onDefaultValChange={onDefaultValChange}
        onDefaultTimeDimensionStartChange={onDefaultTimeDimensionStartChange}
        onDefaultTimeDimensionEndChange={onDefaultTimeDimensionEndChange}
        onDefaultTimeDimensionLastNObservationsChange={onDefaultTimeDimensionLastNObservationsChange}
        onDefaultTimeDimensionLastNPeriodsChange={onDefaultTimeDimensionLastNPeriodsChange}
        onDefaultTimeDimensionModeChange={onDefaultTimeDimensionModeChange}
        onCodelistSelect={onCodelistsForSelectorShow}
        onConceptSelect={onConceptSchemesForSelectorShow}
        onConceptSchemeSelect={onMeasureDimensionConceptSchemesForSelectorShow}
        onNotDisplayedCodesSelectorShow={onNotDisplayedCodesSelectorShow}
        onDefaultCodesSelectorShow={onDefaultCodesSelectorShow}
        onHierarchicalCodelistSelect={onHierarchicalCodelistsForSelectorShow}
      />
    </EnhancedModal>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(DsdsDimensionDetail);
